import "./BestDeals.css";

const BestDeals=()=>{
    return(
        <section className="best-deals">
            <div className="best-deals-container">
                <h2>Looking for best location and price? Just few steps away.</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                <button>Get best deals</button>
            </div>

        </section>
    );
};
export default BestDeals;